var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"menu-item",class:[_vm.classActive, _vm.classWithHighlight],attrs:{"href":_vm.link}},[_c('span',{staticClass:"menu-item__content",class:{ 'menu-item__content--underline': _vm.hasUnderline }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }